import { render, staticRenderFns } from "./gerarPropostaExterna.vue?vue&type=template&id=76127f74"
import script from "./gerarPropostaExterna.vue?vue&type=script&lang=js"
export * from "./gerarPropostaExterna.vue?vue&type=script&lang=js"
import style0 from "./gerarPropostaExterna.vue?vue&type=style&index=0&id=76127f74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports